
import { Component, OnInit, ViewChild } from '@angular/core';
import { AppService } from '../../../app.service';
import { LoadingService } from '../../../shared/services/loading.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ManageComponentsService } from '../manage-components.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ComponentDetailsComponent } from '../component-details/component-details.component';
import { ExcelService } from '../excel-service.service';
import { NotificationsService } from 'angular2-notifications';
import { UploadCompImageComponent } from '../upload-comp-image/upload-comp-image.component';
import { ComponentImageUploadComponent } from '../component-image-upload/component-image-upload.component'
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { AppUris } from '../../../entities/app-config/model';
import { UscoDataComparisonDialogComponent } from '../usco-data-comparison-dialog/usco-data-comparison-dialog.component';
import { PreferencesService } from '../../preferences/preferences.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Model, Make, GetComponentImage, UpdateComponentSproket, ComponentType, MeasurementToolsViewModel } from '../manage-components.model';
import { ComponentExtradetailPopupComponent } from './component-extradetail-popup/component-extradetail-popup.component';
import { GETPreferencesService } from '../../GET_NEW_UI/preferences/preferences.service';
import { CryptoService } from '../../../services/crypto.service';

 
@Component({
  selector: 'manage-components',
  templateUrl: './manage-components.component.html',
  styleUrls: ['./manage-components.component.scss'],
  providers: [ExcelService]
})

export class ManageComponentsComponent implements OnInit {
  displayedColumns = ['ComponentId', 'ComponentDescription', 'ComponentType','Pitch', 'ComponentMake', 'EquipModel'];
  displayedColumns_measurements = ['Tool Name', 'Title', 'Image', 'Created Date'];
  appUris: AppUris;
  //loading
  showTableView: boolean = false
  tableDataLoading: boolean = false
  tableDataLoadingMesurementImage: boolean = false
  showMesurementTable: boolean = false

  // grid Values

  compartid_auto: string;
  progid: string;
  parentCompartID: number;
  public ComponentId: string;
  public ComponentDescription: string;
  public ComponentType: string;
  public ComponentMake: string;
  public EquipModel: string;
  public EquipMake: string;
  public partNo: string;
  public componentName: string;
  public comSubType: number

  public componetTypeId

  //OtherDetails
  public compart: string
  public compart_note: string
  public compartid: string
  public comparttype_auto: number
  public moduleid: string
  public moduledesc: string
  public modified_user: string
  public modified_user_encrypted: string
  public modified_date_short: string
  public Model_Id: string
  public Model_Names: string
  public make_auto: number
  public makedesc: string
  public tool_auto: number
  public toolname: string
  public budget_life: number
  public distanceBudget: number
  public CaseParTNumber:string
  public BERCOPartNumber:string
  public KTSUPartNumber:string
  public OEMPartNumber:string
  public ITMPartNumber:string
  public ITRPartNumber:string
  public Cost:number
  public QuantityInStock:number
  public PartLineId: number;
  public componentPitch: number;


  public track_compart_worn_calc_method_auto: number
  public track_compart_worn_calc_method_name: string
  public smcs_code: number

  //imeasurement Image result
  public measurementImageResult;
  public Title: string
  public ImageDataBase64: string
  public ToolId: number
  public ImageType: string
  public imgcompartid: number

  //getselected row id
  selectedRow;
  selectedRowSprocket;
  selectedRowIndex_: number = 0;

  //componentImageresult
  public attachment: string
  public imageName: string;
  public ImagetoolId: number

  public attachment_comp: string
  public imageName_comp: string;
  public compart_attach_auto: number

  public modelNameID = []
  public modelId = []

  dataSource = new MatTableDataSource();
  dataSource_measurements = new MatTableDataSource();

  //model mat chip variables
  visible: boolean = true;
  selectable: boolean = true;
  removable: boolean = true;
  addOnBlur: boolean = true;

  // Enter, comma
  separatorKeysCodes = [ENTER, COMMA];
  checked: boolean = false
  userName;
  isNew: boolean = true;

  id: number;
  sproketValue:number;
  private sub: any;
  showTableViewSProket:boolean;
  loading: boolean;
  displayedColumns_Sproket = ['CasePart', 'Berco', 'Desc', 'Quantity'];
  dataSource_Sproket = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  partLine: { id: number, name: string }[] = [
    { id: 1, name: 'Alternative' },
    { id: 2, name: 'Green Line' },
    { id: 3, name: 'Main' },
    { id: 4, name: 'Service Line' }
  ];
  isLinear = false;
  userUOM: string;
  Pitch:string;
  constructor(private _router: Router,
    private _loading: LoadingService,
    private _appService: AppService,
    public _componentservice: ManageComponentsService,
    private _sanitizer: DomSanitizer,
    public dialog: MatDialog,
    public excelService: ExcelService,
    private _notify: NotificationsService,
    private route: ActivatedRoute,
    private _pref: PreferencesService,
    private _userPref: GETPreferencesService,
    private _crypto: CryptoService
  ) { }

  ngOnInit() {
    this._appService.setPageTitle('Setup Components');
    this.getUserPref();
    this.dataSource.sort = this.sort;
    //this.getAllCompartList()
    this.getComponentType();
    this.getMeasurementTools();
    this.loadAllModelsList();
    // this._componentservice.getCompartList();
    this.loadAllCompartList();
    this.loadAllMakeList();
    this._appService.GetLoggedInUserName().subscribe(result => {
      this.userName = result
    });
    this.sub = this.route.params.subscribe(params => {
      this.ComponentId = params['id'];
      if (this.ComponentId) {
        this.GetComponentListForGrid();
      }
    })

  }
  filteredModels: Model[]=[];

  componentTypeList:ComponentType[]=[];

  MeasurementToolsViewModel:MeasurementToolsViewModel[]=[];
  
  getMeasurementTools(){
    this._componentservice.getMeasurementTools().subscribe(result => {
      //this.ModelList = result;
      debugger;
      this.MeasurementToolsViewModel = result;
    })
  }
  loadAllCompartList() {
    debugger;
    this._componentservice.getCompartList(this.compartid_auto).subscribe(result => {
     
      this.getCompartList = result;
      
      this.getParentCompartID();
    })
  }

  getFilterCompartList :GetComponentImage[];
  // MakeChanged(event: any) {
  //   if (event.target.value != "") {
      
  //       const filterValue = event.target.value.toLowerCase();
  //       this.getFilterCompartList = this.GetComponentImage.filter(option => option.compart.toLowerCase().includes(filterValue));
      
  //   } else {
  //     //this.make_auto = null;
  //     // if (this.familyId != 0) {
  //     //   this.loadAllMakeList();
  //     // }
  //   }
  // }
  MakeChanged(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      
      // Multi-column filtering logic
      this.getFilterCompartList = this.GetComponentImage.filter(option => 
        option.compart.toLowerCase().includes(filterValue) || // Filter by "compart" column
        option.compartid?.toLowerCase().includes(filterValue)   // Filter by "name" column (example column)
        //option.category?.toLowerCase().includes(filterValue) // Filter by "category" column (example column)
      );
  
    } else {
      // Handle case when input is empty (optional)
      this.getFilterCompartList = this.GetComponentImage // Reset filter
    }
  }
  
  
  parentCompartIDText:string="";
  onSelectMake(event: any) {
    // let id = this.getFilterCompartList.find(f => f.compart == event.value);
    // this.parentCompartID = id.compartid_auto;
    // this.parentCompartIDText =   id.compartid+'- '+id.compart ;
    let id = this.getFilterCompartList.find(f => f.compartid_auto === event.value);

    // Check if id is found before proceeding
    if (id) {
        this.parentCompartID = id.compartid_auto;
        this.parentCompartIDText = `${id.compartid} - ${id.compart}`;
    } 
  }


  getComponentType(){
    this._componentservice.getComponentType().subscribe(result => {
      //this.ModelList = result;
      this.componentTypeList = result;
    })
  }
  loadAllModelsList() {

    this._componentservice.getModelListV2().subscribe(result => {
      //this.ModelList = result;
      this.filteredModels = result;
    })
  }
  makeList:Make[];
  GetComponentImage:GetComponentImage[];
  loadAllMakeList() {
   
    this._componentservice.getComponentMakeList().subscribe(result => {
      //this.ModelList = result;
      this.makeList = result;
    })
  }
  getAllCompartList() {
   
    this._componentservice.getCompartList(this.compartid_auto).subscribe(result => {
      //this.ModelList = result;
      this.GetComponentImage = result;
      this.getFilterCompartList = result;
      this.getParentCompartID();
    })
  }
  getCompartList: GetComponentImage[]
 

  onSetupComponet() {
    this._router.navigate(['manage-components']);

  }

  //component type select
  changeComponentType(value) {
    this.ComponentType = value
  }

  // Fill Grid with Component Details
  GetComponentListForGrid() {
    this.tableDataLoading = true
    this._componentservice.getAllComponentList(this.progid, this.ComponentId, this.ComponentDescription, this.ComponentType, this.EquipMake,
      this.ComponentMake, this.EquipModel,this.Pitch).subscribe(result => {
        console.log("Result", result)
        this.dataSource.data = result;
        this.showTableView = true // show table view after data load
        this.tableDataLoading = false
      });

  }

  //reset component setup page
  componentSetupFormRest() {
    // this.selectRow("");
    this.dataSource.data=[];
    this.showTableView=false;
    this.showMesurementTable=false;
    this.dataSource_measurements.data=[];
    this.ComponentId = ''
    this.ComponentDescription = ''
    this.EquipMake = ''
    this.EquipModel = ''
    this.ComponentMake = ''
    this.ComponentType = ''
    this.partNo = ""
    this.componentName = ""
    this.comSubType = -1
    this.compart_note = ""
    this.smcs_code = null
    this.budget_life = null
    this.moduleid = ""
    this.make_auto = -1
    this.tool_auto = -1
    this.track_compart_worn_calc_method_name = ""
    this.modified_user = ""
    this.modified_user_encrypted = ""
    this.modified_date_short = ""
    this.parentCompartID = -1
    this.checked = false
    this.modelNameID = []
    this.attachment_comp = ""
    this.compart_attach_auto = 0
    this.attachment = ""
    this.isRowClick=false;
  
    this.BERCOPartNumber="";
    this.CaseParTNumber="";
    this.KTSUPartNumber="";
    this.OEMPartNumber="";
    this.ITMPartNumber="";
    this.ITRPartNumber="";
    this.QuantityInStock=0;
    this.Cost=0;
    this.PartLineId=-1;
    this.distanceBudget=0;
    //TT-9648
    this.checked = false;
    this.parentCompartIDText = "";
    this.isNew = true;
    this.compartid_auto = null;
    this.componentPitch = null;
    this.Pitch='';
    this.modelId = [];
  }

  //get other component details
  getComporOtherDetails() {

    this._loading.startLoading();
    this._componentservice.getComponentLisRowData(this.compartid_auto).subscribe(result => {
      // if(this.selectedRowIndex_ != 0)
      //{
      this.compart_note = result[0].compart_note;
      this.make_auto = result[0].make_auto;
      this.tool_auto = result[0].tool_auto;
      this.budget_life = result[0].budget_life;
      this.track_compart_worn_calc_method_name = result[0].track_compart_worn_calc_method_name;
      this.smcs_code = result[0].smcs_code;
      this.modified_user = this._crypto.decrypt(result[0].modified_user);
      this.modified_user_encrypted = result[0].modified_user;
      this.modified_date_short = result[0].modified_date_short;
      this.comparttype_auto = result[0].comparttype_auto;
      this.Model_Id = result[0].Model_Id;
      this.Model_Names = result[0].Model_Names;
      this.distanceBudget = result[0].DistanceBudget;
      this.getCompartExtraDetails();
      this.GetSproketData();
      this._loading.finishedLoading();
      //add model to list for chip list
      this.addModel(1)
      //this.getCompartImage(result[0].tool_auto);
      this.getCompartImage();

      // }
      //else{
      // this._loading.finishedLoading();
      //  }
    });
  }
hasComponentData:boolean;
  getCompartExtraDetails() {

    this._componentservice.getComponentExtraData(this.compartid_auto).subscribe(result => {
      if(result!=null){
        this.CaseParTNumber=result[0].CaseParTNumber;
        this.BERCOPartNumber=result[0].BERCOPartNumber;
        this.KTSUPartNumber=result[0].KTSUPartNumber;
        this.OEMPartNumber=result[0].OEMPartNumber;
        this.ITMPartNumber=result[0].ITMPartNumber;
        this.ITRPartNumber=result[0].ITRPartNumber;
        this.Cost= result[0].Cost;
        this.QuantityInStock= result[0].QuantityInStock;
        this.PartLineId= result[0].PartLineId;
        this.componentPitch= result[0].ComponentPitch;
        if (this.CaseParTNumber != null || 
          this.BERCOPartNumber != null ||
          this.KTSUPartNumber != null ||
          this.OEMPartNumber != null ||
          this.ITMPartNumber != null ||
          this.ITRPartNumber != null) {
           // debugger;
            this.hasComponentData=true;
            
          
      }else{
        this.hasComponentData=false;
      }
      }else{
        this.hasComponentData=false;
      }
     
    });
  }


  getmeasurementImageList() {

    this.showMesurementTable = false
    this.tableDataLoadingMesurementImage = true
    this._componentservice.getComponentMeasurementImg(this.compartid_auto).subscribe(result => {

      this.dataSource_measurements.data = result;
      this.tableDataLoadingMesurementImage = false
      this.showMesurementTable = true
    });
  }

  //get compart Testing Image
  //public componetImageResult;
  //isStandard:boolean=false;
  //getCompartImage(tool_id) {
  //  this._componentservice.getComponentImg(0, Number(this.compartid_auto), 2, 0, this.comparttype_auto, tool_id, 0).subscribe(result => {
  //    this.componetImageResult = result
  //    if (result != null) {
  //      this.changeTool(tool_id);
  //    }
  //    else {
  //      this.attachment = ""
  //      this.imageName = ''
  //    }
  //    this.getCompartImageLeft();
  //  });

  //}

  changeTool = (tool_id) => {
    this.attachment = ''
    this.imageName = ''
    if (this.componetImageResult_) {
      this.componetImageResult_.map(item => {
        if (item.tool_auto === tool_id) {
          this.attachment = item.attachment;
          this.isStandardComp=item.isStandard;
        }
      });
    }
  }

  //get componentImage

  public componetImageResult_;

  isStandardComp:boolean=false;

  getCompartImage() {
    //this._componentservice.getComponentTestingPointImg(0,Number(this.compartid_auto), 5, 0, this.comparttype_auto, -1, 0).subscribe(result => {
    this._componentservice.getComponentImg(0, Number(this.compartid_auto), 1, 0, this.comparttype_auto, -1, 0).subscribe(result => {
      if (result) {
        this.componetImageResult_ = result
        this.attachment_comp = this.componetImageResult_.attachment;
        this.imageName_comp = this.componetImageResult_.imageName;
        this.compart_attach_auto = this.componetImageResult_.compart_attach_auto;
        this.isStandardComp = this.componetImageResult_.isStandard;
       // this.getParentCompartID();
      }
    });
  }

  //get component type ID from Row click
  getComponentTypeID = (key) => {
    let comtype = this._componentservice.componentTypeList;
    comtype.map(item => {
      if (key.ComponentType == item.Title) {
        this.comSubType = item.Id;
      }
    })
  }
  isRowClick:boolean=false;
  // //get values from table row click
  selectRow(row) {
    this.isRowClick = true;
    this.selectedRow = row;
    this.selectedRowIndex_ = 1
    this.partNo = row.ComponentId;
    this.componentName = row.ComponentDescription;
    this.comSubType = +row.ComponentType_Id;
    this.compartid_auto = row.compartid_auto;
    this.ComponentMake = row.ComponentMake;
    this.getComporOtherDetails();
    this.getmeasurementImageList();
    //this.getComponentTypeID(row);
    this.isNew = false;
    this.getAllCompartList();

  }
  // get Measurement Image Row data
  getrowMeasuremetDetails(row) {
    this.Title = row.Title;
    this.ToolId = row.ToolId;
    this.ImageDataBase64 = row.ImageDataBase64;
    this.ImageType = row.ImageType;
    this.openSaveMeasurement(1);
  }
  sanitize(image: string) {

    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }
  //measurement Dialog
  openSaveMeasurement(value): void {
    let dialogRef
    if (value == 0) {
      dialogRef = this.dialog.open(ComponentDetailsComponent, {
        width: '50%',
        height: '50%',
        data: { Title: this.Title = "", ImageDataBase64: this.ImageDataBase64 = "", ToolId: this.ToolId = -1, ImageType: this.ImageType = "", compartid_auto: this.compartid_auto }
      });
    }
    else {
      dialogRef = this.dialog.open(ComponentDetailsComponent, {
        width: '50%',
        height: '50%',
        data: { Title: this.Title, ImageDataBase64: this.ImageDataBase64, ToolId: this.ToolId, ImageType: this.ImageType, compartid_auto: this.compartid_auto }
      });
    }

    dialogRef.afterClosed().subscribe(result => {
      this.getmeasurementImageList()
    });
  }

  //ComponentTEstting Image DIALOG

  //openSaveCompImage(): void {
  //  let dialogRef = this.dialog.open(UploadCompImageComponent, {
  //    width: '50%',
  //    height: '50%',
  //    data: { attachment: this.attachment, tool_auto: this.tool_auto, imageName: this.imageName, componetImageResult: this.componetImageResult, 
  //      comparttype_auto: this.comparttype_auto, modified_user: this.modified_user,compartid_auto: Number(this.compartid_auto ),isStandard:this.isStandard},

  //  });

  //}

  //Open USCO part Dialog
  // selectedMake:string;
  // selectedMakeID:number;
  
  // selectedModel:string;
  // selectedModelID:number;

  // selectedCompType:string;
  // selectedCompTypeID:number;
  openUSCOPartUpdateDialog(): void {
    let dialogRef = this.dialog.open(UscoDataComparisonDialogComponent, {
      width: '50%',
     
      data: {
        selectedMakeID:this.make_auto,
        selectedMake:this.ComponentMake,
        selectedCompType: this.ComponentType,
        selectedCompTypeID: this.comparttype_auto,
        selectedModel:this.Model_Names,
        selectedModelID:this.modelId,
        selectedPartId:this.compartid_auto,
        TT_PartDesc:this.componentName,
      },

    });

  }

  //componentiMAGE dIALOG

  openSaveCompImageUpload(): void {
    let dialogRef = this.dialog.open(ComponentImageUploadComponent, {
      width: '50%',
      height: '50%',
      data: {
        attachment_comp: this.attachment_comp,
        imageName_comp: this.imageName_comp,
        comparttype_auto: this.comparttype_auto,
        modified_user: this.modified_user,
        compartid_auto: Number(this.compartid_auto),
        compart_attach_auto: this.compart_attach_auto
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCompartImage()
    });
  }

  getParentCompartID() {

    this._componentservice.getParentID(this.compartid_auto).subscribe(result => {
      this.parentCompartID = result;
      if (this.parentCompartID > 0) {
        this.checked = true;
        let id = this.GetComponentImage.find(f => f.compartid_auto == this.parentCompartID);
        this.parentCompartID = id.compartid_auto;
        this.parentCompartIDText =   id.compartid+'- '+id.compart ;
      }
      else
        this.checked = false;
    });

  }


  // export to excel

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.dataSource.data, 'Component Details');
  }


  //add Model to matchip
  addModel(id: number): void {
    if (id == 0) {

      console.log("moduleid", this.moduleid, this.modelId, this.modelNameID)

      var check = this.modelId.find(x => x == this.moduleid)
      if (!check) {
        //comming from model dropdown select
        this.modelId.push(this.moduleid);

        this.filteredModels.map(x => {
          if (x.Id == parseInt(this.moduleid)) {
            this.modelNameID.push(x.Title)

          }
        })
      }

    } else if (id == 1) {
      //comming from Table row

      //get modelname array
      this.modelNameID.splice(0, this.modelNameID.length)
      this.modelId.splice(0, this.modelId.length)

      let modal_name = this.Model_Names.split(",")
      modal_name.forEach(element => {
        this.modelNameID.push(element)

      });

      let idwithname = this.Model_Id.split(",")
      idwithname.forEach(element => {
        this.modelId.push(element.split(':')[0])
      });
    }

  }
  SelectedComponentTypeValue(event:any){
    console.log(event.value)
    this.comSubType=event.value;

  }

  removeModel(title: any): void {
    let index = this.modelNameID.indexOf(title);

    if (index >= 0) {
      this.modelNameID.splice(index, 1);
      this.filteredModels.map(x => {
        if (x.Title == title) {
          this.modelId.splice(index, 1);
        }
      })
    }



  }

  //Save and Update Compart

  save_updateCompart() {
    this.loading = true;
    if (this.checked == false)
      this.parentCompartID = 0
    this._componentservice.saveCompartDetails(this.compartid_auto, this.partNo, this.componentName, this.comSubType,
      this.tool_auto, this.smcs_code, this.userName, this.compart_note, this.make_auto, 
      this.budget_life, this.modelId, this.parentCompartID,this.distanceBudget, 
      this.CaseParTNumber,this.BERCOPartNumber,this.KTSUPartNumber,this.OEMPartNumber,
      this.ITMPartNumber,this.ITRPartNumber,this.Cost,this.QuantityInStock,this.PartLineId, this.componentPitch)
      .subscribe(result => {
        //console.log("result,",result);
        if(result.Succeed)
        {
          this._notify.success('Saved', 'New Component');
          this.hasComponentData=true;
          this.compartid_auto = result.Id.toString();
          this.loading = false;
          this.isRowClick = true;
          this.partNo = this.partNo;
          this.componentName = this.componentName;
          this.getComporOtherDetails();
          this.getmeasurementImageList();
          //this.getComponentTypeID(row);
          this.isNew = false;
          this.getAllCompartList();
        }
        else
        {
          //console.log("result.Message,",result.Message);
          this._notify.error('Error', result.Message);
          this.loading = false;
        }
      });
  }


  delete_comaprt() {
    this._componentservice.deleteCompart(this.compartid_auto).subscribe(result => {
      this._notify.success('Sucessfuly ', 'Deleted the select component');
    });
  }
  navigateToWornLimit() {
    // this._appService.getAppUris().subscribe(a => {
    //   window.open(a.oldUCUri + 'Track/UndercarriageWornLimit.aspx?compart_auto=' + this.compartid_auto + '&tool_auto=' + this.tool_auto, 'TrackWornLimitSetup');
    // })
  //  window.open('/setup-worn-limit/'+ this.compartid_auto+'/'+ this.tool_auto, '_blank')

  this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    if(res=="True"){
      this._router.navigate(['/setup-worn-limit', this.compartid_auto, this.tool_auto]);
    }else{             
      window.open('/setup-worn-limit/'+ this.compartid_auto+'/'+ this.tool_auto, '_blank')
     
    }
});
  }
  SCasePart:string;
  SBerco:string;
  SDescription:string;
  SQuantity:number;

  update_sproket(isAddUpdate:number) {

    if(this.hasComponentData){
   
    let isUpdate:number;
    if(isAddUpdate==1){
      isUpdate=0;
    }else{
      isUpdate=1;
    }
    this._componentservice.updateSproketHardware(this.compartid_auto,this.SCasePart,
      this.SBerco,this.SDescription,this.SQuantity,null,0,0 ,isUpdate).subscribe(result => {
        this._notify.success('Saved', 'Data updated');
        this.SCasePart="";
        this.SBerco="";
        this.SDescription="";
        this.SQuantity=null;
        this.GetSproketData();
    });
  }else{
    let dialogRef = this.dialog.open(ComponentExtradetailPopupComponent, {
      width: '400px',
    });
    dialogRef.afterClosed().subscribe(result => {
     // this.getCompartImage()
    });
  }
  }

  update_sproket_Data(isAddUpdate:number, row:UpdateComponentSproket) {

    if(this.hasComponentData){
      
   
    let isUpdate:number;
    if(isAddUpdate==1){
      isUpdate=0;
    }else{
      isUpdate=1;
    }

    this.SCasePart= row.CasePartNumberSproket;
    this.SBerco=row.BercoPartNumberSproket;
    this.SDescription=row.Description;
    this.SQuantity=row.Quantity;
    this._componentservice.updateSproketHardwareData(row.PartConfiqAuto,this.compartid_auto,this.SCasePart,
      this.SBerco,this.SDescription,this.SQuantity,null,0,0 ,isUpdate).subscribe(result => {
        this._notify.success('Saved', 'Data updated');
        this.SCasePart="";
        this.SBerco=""
        this.SDescription="";
        this.SQuantity=null;
        this.GetSproketData();
    });
  }else{
    let dialogRef = this.dialog.open(ComponentExtradetailPopupComponent, {
      width: '400px',
    });
    dialogRef.afterClosed().subscribe(result => {
     // this.getCompartImage()
    });
  }
  }
  updateComponentSproket:UpdateComponentSproket[]=[];


  GetSproketData() {
    
    this._componentservice.GetSproket(+this.compartid_auto).subscribe(result => {
     if(result!=null){
      this.dataSource_Sproket.data = result;
     }
     this.showTableViewSProket=true;
    });
  }
  
  selectedTabValue(event){
    console.log(event);
    let labelName = event.tab.textLabel;
    if(labelName=='Sproket Hardware'){
      //this.GetSproketData();
    }
  }
  IsSproketUpdate:boolean=false;
  selectRowSprocket(row) {
    this.IsSproketUpdate=true;
    this.isRowClick = true;
    this.selectedRowSprocket = row;
    this.SCasePart=row.CasePartNumberSproket;
    this.SBerco= row.BercoPartNumberSproket;
    this.SDescription=row.Description;
    this.SQuantity=row.Quantity;

  }

 getUserPref(){
    this._userPref.getUserPreferences().subscribe(res => {
      this.userUOM = res.UnitOfMeasurementName;
    });
  }

}

